<template>
    <div class="row">
        <div class="col-12">
          <div class="card-header-actions">
            <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
              <button class="all-btn add-btn pull-right" @click="showRentalRatesForLegalModal(null)">
                {{$t("action.add")}}
              </button>
            </div>
          </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>#</th>
                      <th>Вилоят</th>
                      <th>Қарор сони</th>
                      <th>Қарор санаси</th>
                      <th>Илова хужжати</th>
                      <th>Яратилган сана</th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                  <tr v-for="result in results.data" :key="result.id">
                      <td>{{result.id}}</td>
                      <td>{{result.data.province.name}}</td>
                      <td>{{result.data.decisionNumber}}</td>
                      <td>{{result.data.decisionDate}}</td>
                      <td v-if="result.applications">
                          <div v-for="(photo) in result.applications" :key="photo.id" class="mb-2">
                              <img :src="photo.filePath" id="appImage" style="max-width: 100px;max-height: 100px; cursor: pointer;" v-if="photo && photo.filePath" @click="onClickPhoto(photo)"/>
                          </div>
                      </td>
                      <td>
                          {{new Date(result.createdDate) | dateFormat('DD/MM/YYYY HH:mm')}}
                      </td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <RRApplicationLegalEditModal @change="initList"></RRApplicationLegalEditModal>
    </div>
</template>

<script>
    import RRApplicationLegalEditModal from "@/views/config/rental_rates/RRApplicationLegalEditModal";
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';

    export default {
        name: "RRApplicationLegalList",
        components: {
            RRApplicationLegalEditModal,
            'b-pagination': bPagination
        },
        props: {
            type: String
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                const vm = this;
                this.$http.post('dictionary/real-estate/rental-rates/list/RENTAL_RATES_APPLICATION_FOR_LEGAL', this.filter)
                    .then(res => {
                        this.results = res.data;
                        vm.loading = false;
                    }, err => {
                        console.log(err);
                        vm.loading = false;
                    });
            },
            showRentalRatesForLegalModal(data) {
                this.$eventBus.$emit('showRRApplicationLegalEditModal', data)
            },
            onClickPhoto(file) {
                window.open(file.filePath,'_blank');
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            }
        },
        created() {
            this.initList()
        }
    }
</script>

<style scoped>

</style>